export var E_PATENT_PERMISSION_TYPE;
(function (E_PATENT_PERMISSION_TYPE) {
    E_PATENT_PERMISSION_TYPE["READ"] = "read";
    E_PATENT_PERMISSION_TYPE["EDIT"] = "edit";
})(E_PATENT_PERMISSION_TYPE || (E_PATENT_PERMISSION_TYPE = {}));
export var E_FIELD_PERMISSION_TYPE;
(function (E_FIELD_PERMISSION_TYPE) {
    E_FIELD_PERMISSION_TYPE["READ"] = "read";
    E_FIELD_PERMISSION_TYPE["EDIT"] = "edit";
    E_FIELD_PERMISSION_TYPE["LABEL"] = "label";
    E_FIELD_PERMISSION_TYPE["HIDE"] = "hide";
})(E_FIELD_PERMISSION_TYPE || (E_FIELD_PERMISSION_TYPE = {}));
export var E_COMMENT_PERMISSION_TYPE;
(function (E_COMMENT_PERMISSION_TYPE) {
    E_COMMENT_PERMISSION_TYPE["READ"] = "read";
    E_COMMENT_PERMISSION_TYPE["LABEL"] = "label";
    E_COMMENT_PERMISSION_TYPE["HIDE"] = "hide";
})(E_COMMENT_PERMISSION_TYPE || (E_COMMENT_PERMISSION_TYPE = {}));
export var E_OTHER_PERMISSION_TYPE;
(function (E_OTHER_PERMISSION_TYPE) {
    E_OTHER_PERMISSION_TYPE["FOLDER_CREATE"] = "folder_create";
    E_OTHER_PERMISSION_TYPE["FOLDER_EDIT"] = "folder_edit";
    E_OTHER_PERMISSION_TYPE["FOLDER_COPY"] = "folder_copy";
    E_OTHER_PERMISSION_TYPE["FOLDER_MOVE"] = "folder_move";
    E_OTHER_PERMISSION_TYPE["FOLDER_DELETE"] = "folder_delete";
    E_OTHER_PERMISSION_TYPE["ASSIGN"] = "assign";
    E_OTHER_PERMISSION_TYPE["EXPORT"] = "export";
})(E_OTHER_PERMISSION_TYPE || (E_OTHER_PERMISSION_TYPE = {}));
export var E_FOLDER_ROLE;
(function (E_FOLDER_ROLE) {
    E_FOLDER_ROLE["OWNER"] = "OWNER";
    E_FOLDER_ROLE["STRANGER"] = "STRANGER";
    E_FOLDER_ROLE["READ"] = "READ";
    E_FOLDER_ROLE["EDIT"] = "EDIT";
    E_FOLDER_ROLE["MANAGE"] = "MANAGE";
    E_FOLDER_ROLE["CUSTOM"] = "CUSTOM";
    E_FOLDER_ROLE["LABEL"] = "LABEL";
})(E_FOLDER_ROLE || (E_FOLDER_ROLE = {}));
export var TotalCountKey;
(function (TotalCountKey) {
    TotalCountKey["TOTAL_BIO_COUNT"] = "total_bio_count";
    TotalCountKey["TOTAL_CLINICAL_COUNT"] = "total_clinical_count";
    TotalCountKey["TOTAL_DRUG_COUNT"] = "total_drug_count";
    TotalCountKey["TOTAL_MA_COUNT"] = "total_ma_count";
    TotalCountKey["TOTAL_MR_COUNT"] = "total_mr_count";
    TotalCountKey["TOTAL_PAPER_COUNT"] = "total_paper_count";
    TotalCountKey["TOTAL_PATENT_COUNT"] = "total_patent_count";
    TotalCountKey["TOTAL_VC_COUNT"] = "total_vc_count";
})(TotalCountKey || (TotalCountKey = {}));
